// For any type of user form
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  connect() {
    $(this.element).on("keypress", "input:not(textarea):not([type=submit])", function(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
      }
    });
  }

}